const formatDate = (date) => date.slice(5).replace('-', '/'); // mm/DD

// Takes last _numberOfDays_ days  from the array and produces a series of data based on it.
// Then takes another _numberOfDays_, and so on, up to _periods_ times, so that it can be
// presented as multiple Lines on a single chart.
// Refer to the test file for an example.
export const serializeMultiActivityData = (activity, numberOfDays = 7, periods = 1) => {
  if (!activity || !activity.datestamp) {
    return [];
  }

  const totalCount = activity.datestamp.length;
  const activityMap = [];

  for (let day = 0; day < numberOfDays; day += 1) {
    const dataPoint = {
      name: numberOfDays - day,
    };

    for (let period = 0; period <= periods - 1; period += 1) {
      const dataPointIndex = totalCount - 1 - period * numberOfDays - day;

      if (activity.datestamp[dataPointIndex]) {
        dataPoint[`datestamp${periods - period}`] = formatDate(activity.datestamp[dataPointIndex]);
      }
      if (activity.jobs && Number.isFinite(activity.jobs[dataPointIndex])) {
        dataPoint[`tests_by_day${periods - period}`] = activity.jobs[dataPointIndex];
      }
      if (activity.ccy_exec_peak && Number.isFinite(activity.ccy_exec_peak[dataPointIndex])) {
        dataPoint[`peak_vm_ccy${periods - period}`] = activity.ccy_exec_peak[dataPointIndex];
      }
    }

    activityMap.unshift(dataPoint);
  }

  return activityMap;
};

export const getDateRange = ({ since, until = new Date() }) => (
  Math.ceil((until - since) / 24 / 60 / 60)
);
